























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { urlBuilderBlockNumber } from '@/utils/explorerGuide';

@Component
export default class Card extends Vue {
  @Prop({ default: false}) public open!: boolean;
  @Prop(String) public nature!: string;
  @Prop(String) public natureDesc!: string;
  @Prop(String) public type!: string;
  @Prop(String) public extrinsicHash!: string;
  @Prop(String) public lifetime!: string;
  
  getExplorerUrl(value: string) {
    return urlBuilderBlockNumber(value, 
      this.$store.state.explorer.chain, 
      this.$store.state.explorer.provider)
  } 
}
